<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a>Contents</h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/ch0007_foreword"><em>Foreword by Marshall Goldsmith</em></a></p>
<p class="tocfront"><a class="nounder" href="#/xhtml/ch0008_introduction"><strong><em>Introduction: </em></strong> Change Your Stories, Change Your Life</a></p>
<p class="tocpart"><a class="nounder" href="#/xhtml/ch0009_part01"><strong>Parable</strong></a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01">Challenges of Work and Life</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">People Stories</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">Situation Stories</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">Self Stories</span></p>
<p class="part"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample"><strong><em>Afterword:</em></strong> Find Your Heroic Inspiration</span></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/ch05_part02" title="Link target outside of Sample"><strong>Resource Guide</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">Overview of Book and Online Resources</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">Recognize Your Stories</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample">Build a Community of Heroes Around You</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample">Take Actions to Encourage the Hero in You</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch10" title="Link target outside of Sample">Hero Tips for Managers</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch11" title="Link target outside of Sample">First Steps to Take Today</span></p>
<p class="tocbacka"><span class="nounder" href="#/xhtml/ack" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/abt" title="Link target outside of Sample"><em>About the Author</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch0006_toc.vue?2f0f3acd